import { type ComponentPropsWithoutRef } from 'react';
import { Checkbox } from '../control/checkbox';
import { SelectContent } from './SelectContent';
import { SelectItem } from './SelectItem';
import { type SelectOption } from './type';
type MultiSelectContentProps<T extends string = string> = Omit<ComponentPropsWithoutRef<typeof SelectContent>, 'onSelect'> & {
  close: () => void;
  onSelect?: (value: T) => void;
  options: SelectOption<T>[];
  values: T[];
  maxCount?: number;
  className?: string;
  showScrollbar?: boolean;
};
export const MultiSelectContent = <T extends string = string,>({
  onSelect,
  close,
  options,
  values,
  maxCount,
  className,
  showScrollbar,
  ...props
}: MultiSelectContentProps<T>) => {
  const isOptionSelected = (option: SelectOption<T>, value: T[] | null) => {
    if (!value) return false;
    return value.some(v => v === option.value);
  };
  return <SelectContent {...props} onPointerDownOutside={close} className={className} showScrollbar={showScrollbar} data-sentry-element="SelectContent" data-sentry-component="MultiSelectContent" data-sentry-source-file="MultiSelectContent.tsx">
      {options.map(option => <SelectItem key={option.value} value={option.value} checked={isOptionSelected(option, values)} leftSlot={<Checkbox checked={isOptionSelected(option, values)} />} label={option.label} invalid={option.invalid} onClick={() => {
      onSelect?.(option.value);
    }} disabled={option.disabled || maxCount != null && maxCount !== 0 && values.length >= maxCount && !values.includes(option.value)} />)}
    </SelectContent>;
};